var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 9 14.969"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M0 4.494l2.99 2.988L0 10.47v4.5h9v-4.5L6.01 7.482 9 4.494v-4.5H0v4.5zm1.51 6.363L4.5 7.869l2.99 2.988H1.51zm0-9.387h5.98v2.637H1.51V1.47z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }